<template>
<div class="box">
  <article class="media" v-for="guest in guests">
    <div class="media-content">
      <div class="content">
        <h5 style="color: #008000">{{guest.event.name}}({{guest.sale.ticket.name}})</h5>
        <button v-if="isBuyer(guest)" class="delete is-large deletebtn" v-on:click="deleteTicket(guest)"></button>
        <strong>Status: </strong>{{statusReturn(guest.status)}}<br>
        <strong>Participante: </strong>{{guest.person.name}}<br>
        <strong>Documento: </strong>{{guest.person.document}}<br>
        <strong>Email: </strong>{{guest.person.email}}<br>
        <strong>Telefone: </strong>{{guest.person.phone}}
      </div>
    </div>
  </article>
</div>
</template>

<script>
export default {
  data() {
    return {
      guests: [],
      person: this.$router.person,
    }
  },
  mounted: function() {
    this.listTickets()
  },
  methods: {
    statusReturn(status) {
      console.log(status)
      switch (status) {
        case 1:
          return 'Ativo'
          break
        case 3:
          return 'Cancelado'
          break
      }
    },
    listTickets() {
      let person = JSON.parse(localStorage.getItem("data"))

      let query = {
        "query": `{
          sales_by_event(person: ${person.id}, event: ${process.env.EVENT_ID}) {
            guests {
              status
              event {
                id
                name
              }
              person {
                id
                name
                document
                email
                phone
              }
              sale {
                id
                ticket{
                  name
                }
              }
            }
          }
        }`
      }

      this.$http.post(process.env.API_URL, query).then((response) => {
          let sales = response.body.data.sales_by_event
          this.guests = []
          sales.map(sale => {
            if (sale.guests.length !== 0)
              sale.guests.map(guest => this.guests.push(guest))
          })

        },
        (response) => {
          console.log(response);
        })
    },
    deleteTicket(guest) {
      swal({
          title: "Você tem certeza?",
          text: `Deseja remover ticket de ${guest.person.name} da lista de convidados!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Sim, confirmar !",
          cancelButtonText: "Não, cancelar !",
          closeOnConfirm: true,
          closeOnCancel: false
        },
        isConfirm => {
          if (isConfirm) {
            let query = {
              "query": `mutation destroyParticipant {
               destroyParticipant(input: { person_id: ${guest.person.id}, event_id: ${guest.event.id} }) {
                 participant { observation }
                 message
               }
              }`
            }

            this.$http.post(process.env.API_URL, query).then((response) => {
              var msg = {
                title: "Participante apagado",
                text: 'O participante foi apagado com sucesso',
                type: "success",
                hide: true
              }
              location.reload()
            });
          } else {
            swal("Cancelado", "Participante não foi excluído!", "error");
          }
        });
    },
    isBuyer(guest) {
      let person = JSON.parse(localStorage.getItem("data"))
      return guest.person.id != person.id
    }
  }
}
</script>

<style>
html {
  background-color: rgb(44, 51, 56) !important;
}

.deletebtn {
  position: relative;
  float: right;
}
</style>



// WEBPACK FOOTER //
// Tickets.vue?61d51356